import { FlyoutLink } from "@app/shared/Flyouts";
import { ChangeEvent, FC, useEffect, useState } from "react";
import ManageSavedFiltersFlyout from "@app/shared/manage-saved-filters/ManageSavedFiltersFlyout";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";

interface ManageSavedFiltersProps {
  loadSavedFiltersList: () => Promise<string[]>;
  filterValue: string;
  onFilterChange: (filterSelection: string) => void;
  onSubmit: (filtersToDelete: Set<string>, filterNameUpdates: Map<string, string>) => Promise<void>;
}

const ManageSavedFilters: FC<ManageSavedFiltersProps> = ({
                                                           filterValue,
                                                           loadSavedFiltersList,
                                                           onFilterChange,
                                                           onSubmit
                                                         }: ManageSavedFiltersProps) => {
  const [loadedFilters, setLoadedFilters] = useState<string[]>([]);
  const hasNoSavedFilters = !loadedFilters || loadedFilters.length === 0;

  const wrappedOnFilterChange = (changeArgs: ChangeEvent<HTMLSelectElement>) => {
    const valueToSet = changeArgs.target.value;
    onFilterChange(valueToSet);
  }

  const wrappedOnSubmit = async (filtersToDelete: Set<string>, filterNameUpdates: Map<string, string>) => {
    await onSubmit(filtersToDelete, filterNameUpdates);
    const loadedFilters = await loadSavedFiltersList();
    setLoadedFilters(loadedFilters);
  }

  useEffect(() => {
    const loadSavedFilters = async () => {
      const loadedFilters = await loadSavedFiltersList();
      setLoadedFilters(loadedFilters);
    }
    loadSavedFilters().then();
  }, [])

  return (
    <div className="mb-2 row justify-content-start manage-saved-filters__container">
      <QESSelect
        containerClassName="col-12 col-xl-7"
        label="Load Saved Filters"
        testId="manage-saved-filters__saved-filters"
        onChange={wrappedOnFilterChange}
        disabled={hasNoSavedFilters}
        value={filterValue}
      >
        {loadedFilters?.map((f) => (
          <option value={f} key={f}>{f}</option>
        ))}
      </QESSelect>
      <span className="manage-saved-filters__filter-buttons col-auto px-0">
        <FlyoutLink
          classNames="qes-button qes-button-secondary col-auto col-xl-auto"
          testId="manage-saved-filters__manage-filters"
          content={{
            body: <ManageSavedFiltersFlyout onSubmit={wrappedOnSubmit} loadedFilters={loadedFilters}/>,
            title: "Manage Saved Filter Sets",
          }}
        >
            Manage Saved Filters
        </FlyoutLink>
      </span>
    </div>
  )
}

export default ManageSavedFilters;